export default __webpack_public_path__ + "static/media/somethingWentWrong.aee36412.svg";